export const config = {
  API_URL: process.env.VUE_APP_API_URL || 'https://api.pickafund.com',
  idAnalytics: process.env.VUE_APP_ID_GOOGLE_ANALYTICS || 'G-P3CR9ELTBM',
}
